<template>
  <div class="col" style="margin-top: 150px">
    <glcwc-content-blog-post-list inst-key="WFlIywMGaf1AqrLVAErIfQ"
      gen-seo
      orga-key="ZUuaNmvgXkmfqjQlFp3h8Q"
      :selected-index="selectedIndex"
      :layout="layout"
      :key-list-filter="keyListFilter.join()"
      @blog-post-details="handleBlogPostDetails($event.detail[0])" />
  </div>
</template>

<script>
export default {
  name: 'Blog',
  data () {
    return {
      selectedIndex: 0,
      layout: 'table',
      keyListFilter: ['8DSkoWV-gWjo4heazwRWYw', '2BaM_fsj3guvcL_fPojBrA']
    }
  }, // data
  mounted () {
    if (this.$route.params.key) {
      const _selectedIndex = this.keyListFilter.indexOf(this.$route.params.key)
      if (_selectedIndex > -1) {
        this.selectedIndex = _selectedIndex
        this.layout = 'singlePost'
      }
    }
  }, // mounted
  created () {
    /* eslint quote-props: ["error", "as-needed", { "unnecessary": false }] */
    this.$tracker('event', 'screen_view', {
      'app_name': 'magiv',
      'screen_name': 'Blog'
    })
  },
  components: {
  }, // components
  methods: {
    handleBlogPostDetails (key) {
      console.log('TRACE-REMOVE: Blog.handleBlogPostDetails: key is: ', key)
      var _pushUrl = '/blog'
      if (key) {
        _pushUrl += '/' + key
      }
      this.$router.push(_pushUrl)
    } // handleBlogPostDetails
  }
}
</script>
<style scoped>
.cmpn-card-item {
  display: flex;
  flex: 1 0 auto;
  min-width: 200px;
  width: 45%;
}
</style>
